import PlusSmall from './src/plus-small-combined';
export default PlusSmall;